(function () {
  var fmt = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' });
  var fmtGanz = new Intl.NumberFormat('de-DE', { maximumFractionDigits: 0 });
  var debounceTimer = null;

  // Geschuetztes Leerzeichen: Zahl und Euro-Zeichen brechen nie getrennt um
  function euroGanz(eur) { return fmtGanz.format(eur) + ' €'; }

  function debounce(fn, wait) {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(fn, wait || 40);
  }

  function box() {
    return document.getElementById('caribia-indoor-price');
  }

  function parseMoneyToCents(txt) {
    if (!txt) return 0;
    var s = String(txt).replace(/[^\d,.\-]/g, '').trim();
    if (!s) return 0;
    if (s.indexOf(',') >= 0 && s.indexOf('.') >= 0) s = s.replace(/\./g, '');
    s = s.replace(',', '.');
    var euros = parseFloat(s);
    if (isNaN(euros)) return 0;
    return Math.round(euros * 100);
  }

  function parseList(str) {
    return (str || '').split('|').map(function (x) { return parseInt(x, 10) || 0; });
  }

  // ------- Produkt / Variante (wie caribia-outdoor-price) -------
  function findProductJSON() {
    var el = document.querySelector('[data-section-type="static-product"][data-section-id][data-section-data]');
    if (!el) return null;
    try {
      return (JSON.parse(el.textContent || el.innerText || '{}') || {}).product || null;
    } catch (e) {
      return null;
    }
  }

  function getSelectedVariant(product) {
    var checked = document.querySelector('input[name="id"]:checked');
    if (checked) {
      var v = product.variants.find(function (x) { return String(x.id) === String(checked.value); });
      if (v) return v;
    }
    var sel = document.querySelector('select[name="id"]');
    if (sel) {
      var v2 = product.variants.find(function (x) { return String(x.id) === String(sel.value); });
      if (v2) return v2;
    }
    return product.selected_or_first_available_variant || product.variants[0];
  }

  // ------- Preis-Quellen -------
  // Der Theme-Preisblock ist per CSS unsichtbar, bleibt aber im DOM und
  // wird vom Theme bei Varianten-Wechsel aktualisiert (Preis-Quelle).
  function getShopifyBasePriceEl() {
    var sels = [
      '[data-product-pricing] .price__regular .price-item',
      '[data-product-pricing] .price-item--regular',
      '.product__price .price__regular .price-item',
      '.product__price .price-item--regular',
      '.product-pricing .price__regular .price-item',
      '.product-pricing .price-item--regular'
    ];
    for (var i = 0; i < sels.length; i++) {
      var el = document.querySelector(sels[i]);
      if (el) return el;
    }
    return null;
  }

  function getShopifyBasePriceCents() {
    var el = getShopifyBasePriceEl();
    if (!el) return 0;
    return parseMoneyToCents(el.textContent);
  }

  function getAppPriceEl() {
    var b = box();
    var sel = b ? (b.getAttribute('data-price-selector') || '').trim() : '';
    return sel ? document.querySelector(sel) : null;
  }

  function getAppPriceCents() {
    var el = getAppPriceEl();
    if (!el) return 0;
    var attr = el.getAttribute('data-price');
    if (attr && /^\d+$/.test(attr)) return parseInt(attr, 10);
    return parseMoneyToCents(el.textContent);
  }

  // ------- Easify V2: Zubehoer-Aufpreise aus der sichtbaren Auswahl -------
  // V2 haelt die Auswahl nur im React-State (keine Form-Inputs vor Add-to-Cart).
  // Dropdown-Buttons zeigen "Label (€150,00)", angehakte Checkboxen tragen den
  // Preis im Options-Label. Gezaehlt wird NUR was Easify sichtbar anzeigt.
  function getEasifyV2AddonCents() {
    var portal = document.querySelector('.easify.portal') || document.querySelector('.easify');
    if (!portal) return 0;
    var sum = 0;
    var moneyRe = /\(\s*€\s*([\d.,]+)\s*\)|\(\s*\+?\s*([\d.,]+)\s*€\s*\)/;

    function addFromText(txt) {
      if (!txt) return;
      var m = txt.match(moneyRe);
      if (m) sum += parseMoneyToCents(m[1] || m[2]);
    }

    var btns = portal.querySelectorAll('[class*="po-select-button"]');
    for (var i = 0; i < btns.length; i++) {
      addFromText((btns[i].textContent || '').trim());
    }

    var checks = portal.querySelectorAll('input:checked');
    for (var j = 0; j < checks.length; j++) {
      var root = checks[j].closest('[class*="po-option-root"]') || checks[j].parentElement;
      if (root) addFromText((root.textContent || '').trim());
    }

    return sum;
  }

  function getTotalPriceCents(product) {
    var variant = getSelectedVariant(product);
    var base = getShopifyBasePriceCents() || (variant ? (parseInt(variant.price, 10) || 0) : 0);
    var app = getAppPriceCents();
    if (app) {
      if (base <= 0) return app;
      // Heuristik: App >= 60% Basispreis => Gesamtpreis, sonst Aufpreis
      if (app >= Math.round(base * 0.6)) return app;
      return base + app;
    }
    return base + getEasifyV2AddonCents();
  }

  // ------- Staffelrabatt -------
  function getActiveTierIndex(totalCents, boundsEUR) {
    if (boundsEUR.length !== 3) return -1;
    if (totalCents <= boundsEUR[0] * 100) return 0;
    if (totalCents <= boundsEUR[1] * 100) return 1;
    if (totalCents <= boundsEUR[2] * 100) return 2;
    return 3;
  }

  function computeStaffelDiscount(totalCents, boundsEUR, amountsEUR) {
    if (amountsEUR.length !== 4 || boundsEUR.length !== 3) return 0;
    var idx = getActiveTierIndex(totalCents, boundsEUR);
    return Math.min(totalCents, (amountsEUR[idx] || 0) * 100);
  }

  // ------- Gezielte Updates (kein Neu-Rendern, wie Outdoor) -------
  function updatePriceRow(b, totalCents, staffelCents) {
    var finalCents = totalCents - staffelCents;
    var compareEl = b.querySelector('[data-cip-compare]');
    var finalEl = b.querySelector('[data-cip-final]');
    var saveEl = b.querySelector('[data-cip-save]');
    if (compareEl) compareEl.textContent = fmt.format(totalCents / 100);
    if (finalEl) finalEl.textContent = fmt.format(finalCents / 100);
    if (saveEl) saveEl.textContent = '- ' + fmt.format(staffelCents / 100);
  }

  function updateStepper(b, totalCents, boundsEUR, amountsEUR, activeIdx) {
    // Kopfzeile: "Noch X € bis −Y €"
    var nextEl = b.querySelector('[data-cip-next]');
    if (nextEl) {
      if (activeIdx < 3) {
        var need = Math.ceil(boundsEUR[activeIdx] - (totalCents / 100) + 0.01);
        nextEl.innerHTML = 'Noch <strong>' + euroGanz(need) + '</strong> bis <strong>−' + euroGanz(amountsEUR[activeIdx + 1]) + '</strong>';
      } else {
        nextEl.innerHTML = '<strong>Höchste Stufe erreicht ✓</strong>';
      }
    }

    // Segmente: Klassen + Tooltip-Texte (Betraege/Ranges sind statisch)
    var segs = b.querySelectorAll('[data-cip-seg]');
    segs.forEach(function (seg) {
      var s = parseInt(seg.getAttribute('data-cip-seg-idx'), 10);
      seg.classList.remove('cip-st-seg--active', 'cip-st-seg--next');
      if (s === activeIdx) seg.classList.add('cip-st-seg--active');
      else if (s === activeIdx + 1) seg.classList.add('cip-st-seg--next');

      var tipEl = seg.querySelector('[data-cip-seg-tip]');
      if (tipEl) {
        if (s === activeIdx) {
          tipEl.innerHTML = 'Ihr Rabatt: <strong>−' + euroGanz(amountsEUR[s]) + '</strong>, bereits im Preis abgezogen.';
        } else if (s < activeIdx) {
          tipEl.innerHTML = 'Stufe übertroffen: es gilt bereits der höhere Rabatt.';
        } else {
          var needTip = Math.ceil(boundsEUR[s - 1] - (totalCents / 100) + 0.01);
          tipEl.innerHTML = 'Noch <strong>' + euroGanz(needTip) + '</strong> Warenwert bis <strong>−' + euroGanz(amountsEUR[s]) + '</strong>.';
        }
      }
    });

    // Staffel-Modal: aktive Zeile markieren
    var rows = b.querySelectorAll('[data-cip-modal-row]');
    rows.forEach(function (row) {
      var r = parseInt(row.getAttribute('data-cip-seg-idx'), 10);
      if (r === activeIdx) row.classList.add('cip-modal-row--active');
      else row.classList.remove('cip-modal-row--active');
    });
  }

  // ------- Versandstatus: dynamisch nach Zahlbetrag UND gewaehltem Land -------
  function getActiveCountry() {
    var b = box();
    if (!b) return 'DE';
    var btn = b.querySelector('.cip-country-btn--active');
    return btn ? (btn.getAttribute('data-cip-country') || 'DE') : 'DE';
  }

  function setShipRow(title, sub, green) {
    var b = box();
    if (!b) return;
    var titleEl = b.querySelector('[data-cip-ship-title]');
    var subEl = b.querySelector('[data-cip-ship-sub]');
    var iconEl = b.querySelector('[data-cip-ship-icon]');
    if (!titleEl || !subEl) return;
    titleEl.textContent = title;
    titleEl.className = green ? 'cip-ship-title cip-ship-title--green' : 'cip-ship-title';
    subEl.textContent = sub;
    if (iconEl) {
      iconEl.className = green ? 'cip-ship-icon cip-ship-icon--green' : 'cip-ship-icon';
      var svg = iconEl.querySelector('svg');
      if (svg) svg.setAttribute('stroke', green ? '#2a7d3a' : '#999');
    }
  }

  function updateShippingStatus(payCents) {
    var country = getActiveCountry();
    if (country !== 'DE') {
      // AT + CH: Speditionsversand 199,99, keine Kostenlos-Schwelle
      setShipRow('Versand: 199,99 €', 'Speditionsversand aus Deutschland · Rückversand 30 Tage', false);
      return;
    }
    if (payCents >= 140000) {
      setShipRow('Kostenloser Versand', 'Kostenloser Rückversand innerhalb 30 Tagen', true);
    } else if (payCents <= 50000) {
      setShipRow('Versand: 19,95 €', 'Kostenlos ab 1.400 € · Rückversand 30 Tage', false);
    } else {
      setShipRow('Versand: 79,98 €', 'Kostenlos ab 1.400 € · Rückversand 30 Tage', false);
    }
  }

  // ------- Lieferdatum + Countdown (wie Outdoor, Cutoff 14:00) -------
  function addBusinessDays(start, count) {
    var d = new Date(start);
    var added = 0;
    while (added < count) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() !== 0 && d.getDay() !== 6) added++;
    }
    return d;
  }

  function updateDeliveryDate() {
    var b = box();
    if (!b) return;
    var activeBtn = b.querySelector('.cip-country-btn--active');
    var dateEl = b.querySelector('[data-cip-delivery-date]');
    if (!activeBtn || !dateEl) return;
    var minDays = parseInt(activeBtn.getAttribute('data-cip-min'), 10) || 5;
    var maxDays = parseInt(activeBtn.getAttribute('data-cip-max'), 10) || 9;
    var days = ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'];
    var months = ['Jan.', 'Feb.', 'März', 'Apr.', 'Mai', 'Juni', 'Juli', 'Aug.', 'Sep.', 'Okt.', 'Nov.', 'Dez.'];
    function f(d) { return days[d.getDay()] + '. ' + d.getDate() + '. ' + months[d.getMonth()]; }
    var now = new Date();
    dateEl.textContent = f(addBusinessDays(now, minDays)) + ' – ' + f(addBusinessDays(now, maxDays));
  }

  function updateCountdown() {
    var b = box();
    if (!b) return;
    var el = b.querySelector('[data-cip-countdown]');
    if (!el) return;
    var now = new Date();
    var cutoff = new Date(now);
    cutoff.setHours(14, 0, 0, 0);
    if (now >= cutoff) cutoff.setDate(cutoff.getDate() + 1);
    var diff = cutoff - now;
    var h = Math.floor(diff / 3600000);
    var m = Math.floor((diff % 3600000) / 60000);
    var s = Math.floor((diff % 60000) / 1000);
    function pad(n) { return n < 10 ? '0' + n : '' + n; }
    el.textContent = pad(h) + 'h ' + pad(m) + 'm ' + pad(s) + 's';
  }

  // ------- Zahlarten: PayPal-Messaging + Klarna-Raten -------
  // payCents = Preis NACH Staffel- und Juli-Rabatt (tatsaechlicher
  // Zahlbetrag, Basis fuer Raten/Betraege). finalCents = ANGEZEIGTER
  // Preis nach Staffel (Basis fuer die 3.000-€-Offer-Schwelle, damit der
  // Wechsel dann passiert, wenn der Kunde den Preis ueber 3.000 sieht).
  function updatePayments(payCents, finalCents) {
    var b = box();
    if (!b) return;

    var rate = fmt.format(Math.round(payCents / 3) / 100);
    var total = fmt.format(payCents / 100);
    var rateEl = b.querySelector('[data-cip-klarna-rate]');
    if (rateEl) rateEl.textContent = rate;
    var rate2El = b.querySelector('[data-cip-klarna-rate2]');
    if (rate2El) rate2El.textContent = rate;
    var t1El = b.querySelector('[data-cip-klarna-total1]');
    if (t1El) t1El.textContent = total;
    var t2El = b.querySelector('[data-cip-klarna-total2]');
    if (t2El) t2El.textContent = total;
    var t30El = b.querySelector('[data-cip-klarna-total30]');
    if (t30El) t30El.textContent = total;

    // PayPal: BEIDE Messages (Pay in 30 + Ratenzahlung) sind seit dem
    // Seitenaufbau gerendert. Der Schwellen-Wechsel schaltet nur die
    // Sichtbarkeit um (CSS-Klasse), Betraege laufen uebers Attribut.
    // KEIN dynamisches Neu-Rendern, KEIN render()-Aufruf, KEIN Rebuild.
    var ppCard = b.querySelector('[data-cip-paypal]');
    if (ppCard) {
      var payinWrap = ppCard.querySelector('[data-cip-pp-payin]');
      var longWrap = ppCard.querySelector('[data-cip-pp-longterm]');
      var showLongTerm = finalCents > 300000;

      // Attribut nur anfassen, wenn sich der Wert wirklich aendert:
      // jede Attribut-Aenderung loest beim SDK einen Re-Render aus
      var amtStr = (payCents / 100).toFixed(2);
      ppCard.querySelectorAll('[data-pp-message]').forEach(function (m) {
        if (m.getAttribute('data-pp-amount') !== amtStr) {
          m.setAttribute('data-pp-amount', amtStr);
        }
      });

      if (payinWrap && longWrap) {
        payinWrap.classList.toggle('cip-pp-hidden', showLongTerm);
        longWrap.classList.toggle('cip-pp-hidden', !showLongTerm);
      }
    }
  }

  // PayPal-SDK lazy laden (Client-ID aus data-Attribut, offizielles SDK unveraendert)
  function initPaymentSdks() {
    var b = box();
    if (!b) return;
    var clientId = (b.getAttribute('data-pp-client-id') || '').trim();
    if (!clientId || !b.querySelector('[data-pp-message]')) return;

    function loadPaypalSdk() {
      if (window.__cipPaypalSdk) return;
      window.__cipPaypalSdk = true;
      var s = document.createElement('script');
      s.src = 'https://www.paypal.com/sdk/js?client-id=' + encodeURIComponent(clientId) + '&components=messages&currency=EUR';
      s.async = true;
      document.head.appendChild(s);
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) { loadPaypalSdk(); io.disconnect(); }
        });
      }, { rootMargin: '300px' });
      io.observe(b);
    } else {
      if (document.readyState === 'complete') loadPaypalSdk();
      else window.addEventListener('load', loadPaypalSdk);
    }
  }

  // ------- Zentrales Update mit Signatur-Guard -------
  var lastSig = '';
  var lastPayCents = 0;

  function doUpdate() {
    var b = box();
    if (!b) return;
    var product = findProductJSON();
    if (!product || !product.variants) return;

    var bounds = parseList(b.getAttribute('data-bounds'));
    var amounts = parseList(b.getAttribute('data-amounts'));
    var extraEUR = parseInt(b.getAttribute('data-extra'), 10) || 0;

    var variant = getSelectedVariant(product);
    var variantPriceCents = variant ? (parseInt(variant.price, 10) || 0) : 0;
    var total = getTotalPriceCents(product);
    var staffel = computeStaffelDiscount(total, bounds, amounts);
    var activeIdx = getActiveTierIndex(total, bounds);

    // Zahlbetrag an der Kasse: Gesamtpreis minus Staffel- minus Juli-Rabatt
    var payCents = Math.max(0, total - staffel - extraEUR * 100);
    lastPayCents = payCents;

    var sig = total + '|' + staffel;
    if (sig === lastSig) return;
    lastSig = sig;

    updatePriceRow(b, total, staffel);
    updateStepper(b, total, bounds, amounts, activeIdx);
    updateShippingStatus(payCents);
    updatePayments(payCents, total - staffel);
  }

  function update() { debounce(doUpdate, 40); }

  // ------- Beobachter auf Preisknoten (Theme-Preis + App-Preis) -------
  var baseMO = null, appMO = null;

  function observePriceNode(el) {
    if (!el) return null;
    var mo = new MutationObserver(function () { update(); });
    mo.observe(el, {
      childList: true,
      characterData: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-price']
    });
    return mo;
  }

  function initObservers() {
    if (baseMO) baseMO.disconnect();
    if (appMO) appMO.disconnect();
    baseMO = observePriceNode(getShopifyBasePriceEl());
    appMO = observePriceNode(getAppPriceEl());
  }

  // ------- Click-Handling -------
  document.addEventListener('click', function (e) {
    var b = box();
    if (!b) return;

    if (e.target.closest('[data-cip-staffel-open]')) {
      var m1 = b.querySelector('[data-cip-staffel-modal]');
      if (m1) m1.classList.add('is-open');
      return;
    }

    // Staffel-Stufen: Tooltip per Tipp/Klick togglen (Touch hat kein Hover)
    var seg = e.target.closest('[data-cip-seg]');
    if (seg) {
      var wasOpen = seg.classList.contains('cip-st-seg--open');
      b.querySelectorAll('.cip-st-seg--open').forEach(function (s) {
        s.classList.remove('cip-st-seg--open');
      });
      if (!wasOpen) seg.classList.add('cip-st-seg--open');
      return;
    }
    // Klick woanders: offene Stufen-Tooltips schliessen
    b.querySelectorAll('.cip-st-seg--open').forEach(function (s) {
      s.classList.remove('cip-st-seg--open');
    });
    if (e.target.closest('[data-cip-juli-open]')) {
      var m2 = b.querySelector('[data-cip-juli-modal]');
      if (m2) m2.classList.add('is-open');
      return;
    }
    if (e.target.closest('[data-cip-klarna-open]')) {
      var m3 = b.querySelector('[data-cip-klarna-modal]');
      if (m3) m3.classList.add('is-open');
      return;
    }
    if (e.target.closest('[data-cip-ship-open]')) {
      var m4 = b.querySelector('[data-cip-ship-modal]');
      if (m4) m4.classList.add('is-open');
      return;
    }

    var countryBtn = e.target.closest('[data-cip-country]');
    if (countryBtn) {
      b.querySelectorAll('.cip-country-btn').forEach(function (btn) {
        btn.classList.remove('cip-country-btn--active');
      });
      countryBtn.classList.add('cip-country-btn--active');
      updateDeliveryDate();
      updateShippingStatus(lastPayCents);
      return;
    }

    if (e.target.closest('[data-cip-modal-close]')) {
      var openModal = e.target.closest('.cip-modal-overlay');
      if (openModal) openModal.classList.remove('is-open');
      return;
    }
    if (e.target.classList && e.target.classList.contains('cip-modal-overlay')) {
      e.target.classList.remove('is-open');
    }
  });

  // ------- Events -------
  document.addEventListener('change', update);
  document.addEventListener('input', update);
  document.addEventListener('variant:change', update);
  document.addEventListener('variant:changed', update);

  // Mobile: kleinere PayPal-Schrift (Logo bleibt OBEN wie bei Klarna,
  // damit beide Karten gleich aufgebaut und gleich gross sind).
  // Muss VOR dem SDK-Render gesetzt sein.
  function initMobilePaypalStyle() {
    var b = box();
    if (!b) return;
    if (!(window.matchMedia && window.matchMedia('(max-width: 600px)').matches)) return;
    b.querySelectorAll('[data-pp-message]').forEach(function (m) {
      m.setAttribute('data-pp-style-text-size', '12');
    });
  }

  function init() {
    if (!box()) return;
    initMobilePaypalStyle();
    initObservers();
    update();
    updateDeliveryDate();
    updateCountdown();
    initPaymentSdks();
  }

  document.addEventListener('DOMContentLoaded', init);
  window.addEventListener('load', function () {
    initObservers();
    update();
  });
  init();

  setInterval(updateCountdown, 1000);
  // Polling: Easify-V2-Dropdowns sind Custom-Elemente ohne native change-Events.
  // doUpdate aendert dank Signatur-Guard nur bei echter Preis-Aenderung etwas.
  setInterval(function () {
    initObservers();
    update();
  }, 1000);
})();
